import { createContext, useState } from 'react';

function createCtx(defaultValue) {
    const defaultUpdate = () => defaultValue;
    const ctx = createContext({
        fileGroups: defaultValue,
        update: defaultUpdate
    });

    function Provider(props) {
        const [fileGroups, update] = useState(defaultValue);
        return <ctx.Provider value={{ fileGroups, update }} {...props} />;
    }
    return [ctx, Provider];
}

export const [ctx, FileProvider] = createCtx([]);
